import { render, staticRenderFns } from "./ExtendedCountdown.vue?vue&type=template&id=fe856e8e&scoped=true&"
import script from "./ExtendedCountdown.vue?vue&type=script&lang=ts&"
export * from "./ExtendedCountdown.vue?vue&type=script&lang=ts&"
import style0 from "./ExtendedCountdown.vue?vue&type=style&index=0&id=fe856e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe856e8e",
  null
  
)

export default component.exports